import { render, staticRenderFns } from "./ShopTable.vue?vue&type=template&id=dd7ddc52&"
import script from "./ShopTable.vue?vue&type=script&lang=js&"
export * from "./ShopTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports